import {getCurrentYear} from '../../utils/commons'
import GharKeBestPicksLogo from './logo'
import {gharKeBestPicksStylesIN} from './styles'

const baseConfig = {
  domainName: 'gharkebestpicks' as const,
  domainType: 'picks' as const,
  siteName: 'Ghar Ke Best Picks',
  favicon: '/favicons/gharkebestpicks.png',
}

const localeConfigs = {
  in: {
    measurementId: 'G-KT7PBYHZ8S',
    camelCaseUrl: 'GharKeBestPicks.in',
    title: (category: string, count: string) =>
      `Top ${count} ${count} ${getCurrentYear()} in the India | GharKeBestPicks.in  – Expert Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `Discover the best Home & kitchen products with GharKeBestPicks.in. Our expert team provides curated lists, detailed product reviews, and key feature insights to help you select the perfect additions for your home.`,
    logo: <GharKeBestPicksLogo locale="in" />,
    styles: gharKeBestPicksStylesIN,
  },
}

export const createConfig = (locale: string = 'in') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.in
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
